module.exports = __webpack_public_path__ + "img/hrm-ashley-sm.fad7394.png";